
    <div class="row my-3">
      <div class="col text-left "><button (click)="back($event)" class="btn btn-primary">Back</button></div>
    </div>

    <div *ngIf="entity">
      <firmware-definition-widget [entity]="entity" [layout]="'full'" [options]="{}" ></firmware-definition-widget>
    </div>
  